"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const app_1 = require("./app");
const responseError = require("./common/responseError");
function xgetTrialLogs(query, options) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const { userId, courseWorkId, tags = [] } = query;
            const { limit, startAfterTimestamp } = options;
            let trialLogsRef = yield app_1.app.firestore.collection('trialLogs').orderBy('responseData.x_trial_start_timestamp');
            trialLogsRef = trialLogsRef.where('responseData.x_tutorial', '==', false);
            if (limit) {
                trialLogsRef = trialLogsRef.limit(limit);
            }
            if (userId) {
                trialLogsRef = trialLogsRef.where('userId', '==', userId);
            }
            if (courseWorkId) {
                trialLogsRef = trialLogsRef.where('courseWorkId', '==', courseWorkId);
            }
            // Pass the value of last x_trial_start_timestamp to get logs for next limit.
            if (startAfterTimestamp) {
                trialLogsRef = trialLogsRef.startAfter(startAfterTimestamp);
            }
            let results = [];
            if (tags.length) {
                const trialLogsPromises = [];
                for (const tag of tags) {
                    trialLogsPromises.push(trialLogsRef.where('tags', 'array-contains', tag).get());
                }
                const trialLogsResolved = yield Promise.all(trialLogsPromises);
                for (const trialLogResolved of trialLogsResolved) {
                    for (const trialLogDoc of trialLogResolved.docs) {
                        if ((results.findIndex(result => result.id === trialLogDoc.id) === -1)) {
                            results.push(Object.assign({ id: trialLogDoc.id }, trialLogDoc.data()));
                        }
                    }
                }
            }
            else {
                const trialLogDocs = yield trialLogsRef.get();
                results = trialLogDocs.docs.map(trialLogDoc => {
                    return Object.assign({ id: trialLogDoc.id }, trialLogDoc.data());
                });
            }
            return results;
        }
        catch (e) {
            throw new responseError.HttpsError(responseError.FunctionsErrorCode.invalid_argument, e.message);
        }
    });
}
exports.default = xgetTrialLogs;
//# sourceMappingURL=getTrialLogs.js.map